import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import userRating from 'website/containers/user-action/userRating';
import userReviewLink from 'website/containers/user-action/userReviewLink';
import followUnfollowCollectionButtons from 'website/containers/user/followUnfollowCollectionButtons';
import graphFollowUnfollowUser from 'website/containers/user/graphFollowUnfollowUser';
import reviewsSocial from 'website/containers/user/reviewsSocial';
import userCoverMenu from 'website/containers/user/userCoverMenu';
// import share
import initMoreTriggerOverlay from 'website/module/ui/more-trigger-overlay';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initMoreTriggerOverlay();

  // thirdNav
  thirdNav();

  // Social user Action
  userRating();
  userReviewLink();
  reviewsSocial();

  roller();

  graphFollowUnfollowUser();
  followUnfollowCollectionButtons();
  userCoverMenu();

  socialActionsBootstrap();
});
